/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Modal,
  Card,
  DatePicker,
  notification,
  Typography,
  Alert,
} from 'antd';
import {
  CheckCircleOutlined, CheckCircleTwoTone, CloseCircleOutlined,
  ContainerOutlined, FileExcelOutlined, SaveOutlined,
  SearchOutlined,
  SendOutlined,
} from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import { getEstadosGlobales, getMeses } from 'api/catalogos/index';
import {
  cierreDeMes,
  CRUDEvaluacionGeneralClock,
  evaluar,
  URIEvaluacionErrores,
} from 'api/configuraciones/clock/EvaluacionClock/EvaluacionGeneral';
import { checkToken } from 'api/utils';
import {
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import moment from 'moment';
import CRUDgeneric from 'utils/CRUDgeneric';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import ModalErroresControls from 'components/ModalErroresControls';
import { obtenerRegistrosDe } from 'utils/URIsSac';
import { getEmpleadosConDatosOpFilteredPaginated } from 'api/estructuraOrganizacional/empleados';
import CustomSearch from 'components/customSearch';
import { getPlaza } from 'api/catalogos/plazas';
import ReporteFlexibleModal from './ReporteFlexibleModal';

const EvaluacionMensualReloj = (
  {
    permission, recordFather,
    form, errorsVisibleEffect,
    errorsEffect,
  },
) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loadingErrores, setLoadingErrores] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [visibleCloseMonth, setVisibleCloseMonth] = useState(false);
  const [visibleEvaluar, setVisibleEvaluar] = useState(false);
  const [disableFields, setDisableFields] = useState(false);
  const [meses, setMeses] = useState([]);
  const [pageActual, setPageActual] = useState(1);
  const [tiposNominasEmpleados, setTiposNominasEmpleados] = useState([]);
  const [periodosNominasDetalles, setPeriodosNominasDetalles] = useState([]);
  const [periodosNominas, setPeriodosNominas] = useState([]);
  const [periodosFiltered, setPeriodosFiltered] = useState([]);

  const [empleado, setEmpleado] = useState(null);
  const [openSearch, setVisibleSearch] = useState(false);
  const [baseURIPagination, setBaseURIPagination] = useState();
  const [puestosPorEmpleado, setPuestosPorEmpleado] = useState({});
  const [dataSearch, setDataSearch] = useState([]);
  const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);
  const [selectedEmpleadoSearch, setSelectedEmpleadoSearch] = useState();
  let baseURIDatosOpPaginado = 'catalogos/dato-operacional-del-empleado-paginado/?empleados_filter=';

  const [triggerRefresh, setTriggerRefresh] = useState(0);
  const [tiempoEvaluacion, setTiempoEvaluacion] = useState('');
  const [visibleReporteFlexible, setVisibleReporteFlexible] = useState(false);

  const clienteEvaluacion = CRUDEvaluacionGeneralClock;

  //-----------------
  function buildEmisorFields(empleadoResult) {
    return {
      empleado: empleadoResult?.numero_y_nombre_completo,
    };
  }
  const criterioBusqueda = (is_preliminar = true) => { /// falta conectar
    const _empleado = empleado;
    // const _mes = form.getFieldValue('mes');
    // const _periodo_fiscal = form.getFieldValue('periodo_fiscal');
    // const _directorio_areas = form.getFieldValue('directorio_areas');
    return ({
      ...(form.getFieldValue('empleado') && { empleado_id: _empleado }),
      // ...(_mes && { mes_id: _mes }),
      // ...(_periodo_fiscal && { periodo_fiscal_id: _periodo_fiscal }),
      // ...(_directorio_areas && { directorio_de_area_id: _directorio_areas }),
      // ...(is_preliminar && { pre_eliminar: true }),
    });
  };
  const findPuesto = async (empleados) => {
    const nuevosPuestos = {};
    await Promise.all(
      empleados.map(async (emp) => {
        try {
          const plazaEmp = await getPlaza(emp.plaza);
          nuevosPuestos[emp.id] = plazaEmp?.puesto_descripcion || '';
        } catch {
          nuevosPuestos[emp.id] = '';
        }
      }),
    );

    setPuestosPorEmpleado(nuevosPuestos);
  };

  const searchData = async (empId, nombreEmp, apPatEmp, apMatEmp, tipoNominaEmpleado) => {
    setLoading(true);
    if (empId) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}numero_de_empleado=${empId};`;
    }
    if (nombreEmp) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}nombre=${nombreEmp};`;
    }
    if (apPatEmp) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_paterno=${apPatEmp};`;
    }
    if (apMatEmp) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}apellido_materno=${apMatEmp};`;
    }
    if (tipoNominaEmpleado) {
      baseURIDatosOpPaginado = `${baseURIDatosOpPaginado}&tipo_de_nomina_empleado=${tipoNominaEmpleado}&`;
    }
    setBaseURIPagination(baseURIDatosOpPaginado);
    const _empleados = await getEmpleadosConDatosOpFilteredPaginated(baseURIDatosOpPaginado);
    await findPuesto(_empleados.results);
    setDataSearch(_empleados);
    return setLoading(false);
  };
  const validateInput = async (field, setterFields) => {
    setLoading(true);
    setSelectedEmpleadoSearch();
    const searchEmp = form.getFieldValue(field);
    if (!searchEmp) {
      setVisibleSearch(true);
      return setLoading(false);
    }
    const res = await getEmpleadosConDatosOpFilteredPaginated(
      `${baseURIDatosOpPaginado}numero_de_empleado=${searchEmp};`,
    );

    const result = res?.results?.[0];

    if (!res) {
      return setLoading(false);
    }
    const empleadoResult = result?.empleado;
    if (empleadoResult) {
      const fields = setterFields(empleadoResult);
      form.setFieldsValue(fields);
      setEmpleado(empleadoResult?.id);
    } else {
      setEmpleado(null);
      form.resetFields([field]);
    }
    // onChangeEmpleado(empleadoResult?.id);
    return setLoading(false);
  };
  const columnsEmpleado = [
    {
      titleText: 'No. de Empleado',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 200,
      render: (empObject) => empObject?.numero_de_empleado,
    },
    {
      titleText: 'Nombre',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.nombre,
    },
    {
      titleText: 'Apellido Paterno',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.apellido_paterno,
    },
    {
      titleText: 'Apellido Materno',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.apellido_materno,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 300,
      render: (_, empObject) => puestosPorEmpleado[empObject.id],
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado',
      key: 'tipo_de_nomina_empleado',
      width: 250,
      render: (tneEmp) => tiposDeNominaEmpleado?.find((tne) => tne?.id === tneEmp)?.descripcion,
    },
  ];
  //-------------------------

  const [pollingPackage, setPollingPackage] = useState({
    isPolling: false,
    isFinal: null,
    baseline: null,
  });
  const pollingRef = useRef(null);

  const [errores, setErrores] = errorsEffect;
  const { Text } = Typography;
  const [visibleErrores, setVisibleErrores] = errorsVisibleEffect;
  const onErrors = () => {
    setVisibleErrores(true);
  };
  const consultarErrores = async () => {
    //  Consultar errores asociados al registro
    let response = [];
    const erroresResp = await obtenerRegistrosDe(URIEvaluacionErrores, {
      pageActual,
      evaluacion_cierre: recordFather.id,
    });
    if (erroresResp?.results?.length) {
      response = erroresResp; //  Mostrar alerta e historial
    }
    return response;
  };
  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoadingErrores(true);
      const cleanPage = Number(String(page).replace(/\D/g, ''));
      const _data = await consultarErrores();

      const { results } = _data;

      setPageActual(cleanPage);
      setErrores({ ..._data, results: [...results] });
      setLoadingErrores(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const cliente = CRUDgeneric('/relojchecador/cargas-de-reportes-detalles-vista-optimized/');
  const recordName = `el mes ${recordFather?.mes?.nombre} de ${recordFather?.periodo_fiscal?.periodo}`;

  const formInstances = [
    form,
  ];

  const defineDateValues = (value) => {
    if (!value.isValid()) {
      onError('value no es una fecha válida', setLoading, formInstances);
    }
    const firstDay = value.clone().startOf('month');
    const lastDay = value.endOf('month');

    form.setFieldValue('fecha_inicial', firstDay.format('DD-MM-YYYY'));
    form.setFieldValue('fecha_final', lastDay.format('DD-MM-YYYY'));
  };

  useEffect(() => {
    if (recordFather?.tiempo_de_evaluacion) {
      setTiempoEvaluacion(recordFather.tiempo_de_evaluacion);
    } else {
      setTiempoEvaluacion('');
    }
  }, [recordFather]);

  const fetchData = async () => {
    if (!Object.keys(recordFather)?.length > 1) { return; }
    setLoading(true);
    const _data = await cliente.obtenerListaDeRegistros({
      periodo_fiscal_id: recordFather?.periodo_fiscal?.id,
      mes_id: recordFather?.mes?.id,
    });
    setData(formatReceived(_data));
    setLoading(false);
  };

  const filterPeriodos = (_data) => {
    const {
      tipos_de_nominas_empleados,
      periodo_fiscal,
      mes,
    } = form.getFieldsValue();

    const _periodo = periodo_fiscal || _data?.periodo_fiscal;
    const _tipo_nomina = tipos_de_nominas_empleados || _data?.tipos_de_nominas_empleados;
    const _mes = mes || _data?.mes;

    const _periodosNominas = periodosNominas.filter(
      (e) => e.tipo_de_nomina_empleado === _tipo_nomina
        && e.periodo_fiscal === _periodo,
    );

    // filtra por año
    const _periodosDetallesFiltered = periodosNominasDetalles.filter(
      (e) => _periodosNominas.some(((x) => x.id === e.periodo_de_nomina)),
    );

    // filtra por mes
    const _periodosDetallesMonth = _periodosDetallesFiltered.filter(
      (e) => Number(e.mes) === Number(_mes),
    );

    return _periodosDetallesMonth;
  };

  useEffect(() => {
    if (triggerRefresh > 0) {
      fetchData();
    }
  }, [triggerRefresh]);

  useEffect(() => {
    const stopPolling = () => {
      // limpia el intervalo (deja de hacer polling)
      clearInterval(pollingRef.current);
      // resetea la ref para indicar que no hay intervalo activo
      pollingRef.current = null;
      // actualiza estados para detener el polling
      setPollingPackage({
        isPolling: false,
        isFinal: null,
        baseline: null,
      }); // <-- ACTIVAMOS EL POLLING
    };
    // si está activado el polling y hay una nómina en proceso (id definida)
    if (pollingPackage.isPolling && recordFather?.id) {
      // guarda en la ref el id del setInterval para poder limpiarlo después
      setLoading(true);
      pollingRef.current = setInterval(async () => {
        try {
          // obtiene la lista de cálculos/nóminas desde el backend
          const evaluacionActual = await clienteEvaluacion.obtenerUnRegistro(recordFather.id);
          if (!evaluacionActual) {
            stopPolling();
            setLoading(false);
          }
          //  Si hay errores registrados en el backend
          const erroresResp = await consultarErrores();

          if (erroresResp?.length) {
            stopPolling();
            setErrores(erroresResp);
            notification.error({
              message: 'Errores en la Evaluación',
              description: 'Se encontraron errores durante la evaluación. Revisa el historial para más detalles.',
              placement: 'topRight',
            });
            setLoading(false);
          }
          // si la nómina ya tiene evaluacion_terminada significa que terminó.
          // se compara contra el valor previo al disparo (baseline) para no
          // tomar como "completada" una fecha_final_evaluacion vieja de una
          // corrida anterior mientras la tarea nueva sigue encolada/corriendo
          const _fechaFinalActual = pollingPackage.isFinal
            ? evaluacionActual?.fecha_final_evaluacion_final
            : evaluacionActual?.fecha_final_evaluacion;
          if (_fechaFinalActual && _fechaFinalActual !== pollingPackage.baseline) {
            stopPolling();
            // muestra una notificación de éxito al usuario
            const _tiempo_de_evaluacion = pollingPackage.isFinal
              ? evaluacionActual?.tiempo_de_evaluacion_final
              : evaluacionActual?.tiempo_de_evaluacion;
            setTiempoEvaluacion(_tiempo_de_evaluacion);
            notification.success({
              message: 'Evaluación completada',
              description: `La evaluación tomo ${_tiempo_de_evaluacion}.`,
              placement: 'topRight',
              duration: 0, // duración 0 => la notificación permanece hasta que el usuario la cierre
            });
            setTriggerRefresh((prev) => prev + 1);
          }
        } catch (error) {
          stopPolling();
          setLoading(false);
        }
      }, 10000); // intervalo de 10 segundos entre cada comprobación
    }

    // cleanup del useEffect: se ejecuta cuando se desmonta el componente o cambian deps
    return () => {
      // si hay un intervalo activo, lo limpia
      // para evitar fugas y ejecuciones en componentes desmontados
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
    };
    // dependencias: el efecto se vuelve a ejecutar cuando cambian isPolling o nominaEnProcesoId
  }, [pollingPackage.isPolling]);

  useEffect(() => {
    if (
      !recordFather
      || !periodosNominas.length
      || !periodosNominasDetalles.length
    ) {
      return;
    }
    const filtered = filterPeriodos(recordFather);
    setPeriodosFiltered(filtered);
  }, [periodosNominas, periodosNominasDetalles]);

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      await fetchData();
      const erroresResp = await consultarErrores();
      setErrores(erroresResp);
      setLoading(false);
    };
    if (Object.keys(recordFather)?.length > 1) {
      fetchAll();
    }
  }, [recordFather]);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _periodosFiscales,
        _meses,
        _tiposNominasEmpleados,
        _periodosNominas,
        _periodosNominasDetalles,
      ] = await Promise.all([
        getEstadosGlobales(),
        getPeriodosFiscales({ estados_globales: ESTATUS_AUTORIZADO }),
        getMeses(),
        getTiposDeNominasEmpleados({ estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodosDeNominas({ estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodosDeNominasDetalles(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setPeriodosFiscales(_periodosFiscales);
        setMeses(_meses);
        setTiposNominasEmpleados(_tiposNominasEmpleados);
        setPeriodosNominas(_periodosNominas);
        setPeriodosNominasDetalles(_periodosNominasDetalles);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });
  };

  const onConfirmEvaluacion = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      if (Object.keys(recordFather)?.length > 1) {
        // snapshot previo al disparo, para detectar cuándo el backend
        // realmente actualiza fecha_final_evaluacion con la corrida nueva
        const _previo = await clienteEvaluacion.obtenerUnRegistro(recordFather.id);
        await evaluar(recordFather.id);
        setPollingPackage({
          isPolling: true,
          isFinal: false,
          baseline: _previo?.fecha_final_evaluacion ?? null,
        }); // <-- ACTIVAMOS EL POLLING
        setVisibleEvaluar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };
  const onConfirmCloseMonth = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      if (Object.keys(recordFather)?.length > 1) {
        // snapshot previo al disparo, para detectar cuándo el backend
        // realmente actualiza fecha_final_evaluacion_final con la corrida nueva
        const _previo = await clienteEvaluacion.obtenerUnRegistro(recordFather.id);
        await cierreDeMes(recordFather.id);
        setPollingPackage({
          isPolling: true,
          isFinal: true,
          baseline: _previo?.fecha_final_evaluacion_final ?? null,
        }); // <-- ACTIVAMOS EL POLLING
        setVisibleCloseMonth(false);
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const columns = [
    {
      titleText: 'Fecha',
      dataIndex: 'fecha',
      key: 'fecha',
      width: 100,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
      filterMode: 'contains',
    },
    {
      titleText: 'Día',
      dataIndex: 'dia_de_la_semana_nombre',
      key: 'dia_de_la_semana_nombre',
      width: 100,
      filterMode: 'contains',
    },
    {
      titleText: 'No. de Empleado',
      dataIndex: 'numero_de_empleado',
      key: 'numero_de_empleado',
      width: 150,
      filterMode: 'exact-first',
    },
    {
      titleText: 'Nombre del Empleado',
      dataIndex: 'numero_y_nombre_completo_empelado',
      key: 'numero_y_nombre_completo_empelado',
      width: 200,
      filterMode: 'contains',
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_de_area_clave_y_nombre',
      key: 'directorio_de_area_clave_y_nombre',
      width: 200,
      filterMode: 'contains',
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto_clave_y_descripcion',
      key: 'puesto_clave_y_descripcion',
      width: 190,
      filterMode: 'contains',
    },
    {
      titleText: 'Plaza',
      dataIndex: 'plaza_clave_y_descripcion',
      key: 'plaza_clave_y_descripcion',
      width: 200,
      filterMode: 'contains',
    },
    /*
    {
      titleText: 'Horario Jornada Entrada',
      dataIndex: 'horario_jornada_entrada',
      key: 'horario_jornada_entrada',
      width: 150,
    },
    {
      titleText: 'Horario Jornada Salida',
      dataIndex: 'horario_jornada_salida',
      key: 'horario_jornada_salida',
      width: 150,
    },
    */
    {
      titleText: 'Hora de Entrada',
      dataIndex: 'hora_entrada',
      key: 'hora_entrada',
      width: 150,
      filterMode: 'contains',
    },
    {
      titleText: 'Hora de Salida',
      dataIndex: 'hora_salida',
      key: 'hora_salida',
      width: 150,
      filterMode: 'contains',
    },
    // {
    //   titleText: 'Tiempo Trabajado',
    //   dataIndex: 'tiempo_trabajado',
    //   key: 'tiempo_trabajado',
    //   width: 160,
    // },
    {
      titleText: 'Evaluación de Entrada',
      dataIndex: 'tipo_de_evaluacion_entrada',
      key: 'tipo_de_evaluacion_entrada',
      width: 190,
      filterMode: 'contains',
    },
    {
      titleText: 'Evaluación de Salida',
      dataIndex: 'tipo_de_evaluacion_salida',
      key: 'tipo_de_evaluacion_salida',
      width: 180,
      filterMode: 'contains',
    },
    {
      titleText: 'Evaluación Otros',
      dataIndex: 'tipo_de_evaluacion_otro',
      key: 'tipo_de_evaluacion_otro',
      width: 160,
      filterMode: 'contains',
    },
    /*
    {
      titleText: 'Minutos de Incidencia',
      dataIndex: 'minutos_de_incidencia',
      key: 'minutos_de_incidencia',
      width: 190,
    },
    {
      titleText: 'Justificación',
      dataIndex: 'justificacion',
      key: 'justificacion',
      width: 160,
    }, */
  ];

  // const dataNormalizer = (dataArray) => {
  //   if (!Array.isArray(dataArray)) return [];
  //   return dataArray.map((row) => {
  //     const nameToSplit = row?.numero_y_nombre_completo_empelado;
  //     const [number, _] = nameToSplit ? nameToSplit.split(' - ') : '';

  //     return {
  //       ...row,
  //       numero_de_empleado: number,
  //       empleado: row?.numero_y_nombre_completo_empelado,
  //       area: row?.directorio_de_area_clave_y_nombre,
  //       puesto: row?.puesto_clave_y_descripcion,
  //       plaza: row?.plaza_clave_y_descripcion,
  //       horario_jornada_entrada: row.jornada_detalle_horario?.de_las,
  //       horario_jornada_salida: row.jornada_detalle_horario?.a_las,
  //       justificacion: row?.justificacion_reloj_checador?.justificacion,
  //     };
  //   });
  // };

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {
          errores?.results?.length ? (
            <Alert
              description={(
                <code>
                  <Text>
                    Ha ocurrido un error
                  </Text>
                  <br />
                  Favor de consultar el
                  <Text
                    style={{
                      color: '#CF9660',
                      paddingLeft: '3px',
                      paddingRight: '3px',
                    }}
                  >
                    Historial de Errores
                  </Text>
                  para obtener mas información
                </code>
              )}
              type="warning"
              showIcon
              closable
              style={{ textAlign: 'center', alignItems: 'center' }}
            />
          ) : null
        }
        <Form
          layout="vertical"
          form={form}
          scrollToFirstError
          name="general"
          initialValues={{
            estados_globales: ESTATUS_ACTIVO,
          }}
        >
          <Row gutter={10}>
            <Col xs={24} sm={8}>
              <Form.Item
                name="periodo_fiscal"
                label="Año"
                rules={rules.estatus}
                hasFeedback
              >
                <Select
                  dataSource={periodosFiscales}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="fecha_inicial"
                label="Fecha Inicial"
              >
                <Input
                  allowClear
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="fecha_final"
                label="Fecha Final"
              >
                <Input
                  allowClear
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                name="mes"
                label="Mes"
                rules={rules.estatus}
                hasFeedback
              >
                <Select
                  labelProp="nombre"
                  keyProp="id"
                  dataSource={meses}
                  onChange={(value) => {
                    const date = moment().month(value - 1);
                    defineDateValues(date);
                    setPeriodosFiltered(filterPeriodos());
                  }}
                  disabled={Object.keys(recordFather)?.length > 1}
                />
              </Form.Item>
            </Col>
            {/* <Col xs={24} sm={24} md={8}>
                <Row align="middle">
                  <Col xs={24} sm={24} md={24}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                      <Form.Item
                        name="empleado"
                        label="Empleados"
                        hasFeedback
                      >
                        <Input
                          allowClear
                        />
                      </Form.Item>
                      <Button
                        loading={loading}
                        onClick={() => validateInput('empleado', buildEmisorFields)}
                        icon={<SearchOutlined />}
                        style={{
                          width: '3rem',
                          height: '2rem',
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </Col> */}
            {/* <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="tipos_de_nominas_empleados"
                  label="Tipo de Nómina Empleado"
                  rules={rules.estatus}
                  hasFeedback
                >
                  <Select
                    dataSource={tiposNominasEmpleados}
                    disabled={recordFather?.estados_globales?.id === ESTATUS_AUTORIZADO}
                    onChange={() => {
                      setPeriodosFiltered(filterPeriodos());
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="periodo_de_nomina_detalle"
                  label="Periodo"
                  rules={rules.estatus}
                  hasFeedback
                >
                  <Select
                    keyProp="id"
                    labelProp="numero_de_nomina"
                    dataSource={periodosFiltered}
                    disabled={recordFather?.estados_globales?.id === ESTATUS_AUTORIZADO}
                    render={(value) => `${value?.numero_de_nomina}
                    (${value?.fecha_inicial} al ${value?.fecha_final})`}
                  />
                </Form.Item>
              </Col> */}
          </Row>
          <Form.Item hidden>
            <Button htmlType="submit" />
          </Form.Item>
        </Form>
        {Object.keys(recordFather)?.length > 1 && (
          <div style={{ position: 'relative', paddingBottom: tiempoEvaluacion ? '30px' : '0' }}>
            <Table
              cols={columns}
              data={data}
              scroll={{ y: 400 }}
              rowSelection={rowSelection}
              handleOnRowClick={handleOnRowClick}
              disableDelete={selectedData?.estados_globales?.id !== ESTATUS_ACTIVO}
              permission={permission}
              allowExportPDF={false}
              autoFit={false}
              titleTable="Evaluación de Reloj Checador"
              customActions={[
                {
                  onClick: () => setVisibleEvaluar(true),
                  text: 'Evaluación Preliminar',
                  icon: <ContainerOutlined />,
                  disabled: recordFather?.estados_globales?.id !== ESTATUS_ACTIVO,
                  disabledBySelection: false,
                },
                {
                  onClick: () => setVisibleCloseMonth(true),
                  text: 'Evaluación Final',
                  icon: <SendOutlined />,
                  disabled: recordFather?.estados_globales?.id !== ESTATUS_ACTIVO,
                  disabledBySelection: false,
                },
                {
                  onClick: () => setVisibleReporteFlexible(true),
                  text: 'Reporte Flexible',
                  icon: <FileExcelOutlined />,
                  disabledBySelection: false,
                },
              ]}
            />

            {/*  CONTADOR DE TIEMPO RENDERIZADO  */}
            {tiempoEvaluacion && (
              <div style={{
                display: 'flex', alignItems: 'center', position: 'absolute', bottom: -10, right: 0,
              }}
              >
                <CheckCircleTwoTone
                  twoToneColor="#d88f4f"
                  style={{
                    fontSize: '23px',
                    marginRight: '5px',
                  }}
                />
                <Text style={{ fontSize: '0.8rem', color: '#d88f4f' }}>
                  {tiempoEvaluacion}
                </Text>
              </div>
            )}
          </div>
        )}
        <Modal
          open={visibleErrores}
          title={(
            <Row justify="space-between">
              <Text style={{ fontSize: '1.25rem' }}>
                Historial de Errores
              </Text>
              <ModalErroresControls
                onCancel={() => setVisibleErrores(false)}
              />
            </Row>
          )}
          footer={null}
          closable={false}
          width="85%"
        >
          <Table
            loading={loadingErrores}
            cols={[{
              titleText: 'Descripción de Error',
              dataIndex: 'error',
              key: 'error',
              width: 200,
            }]}
            data={errores?.results || []}
            count={errores?.count || 0}
            pagination={false}
            paginationCallback={fetchPaginated}
            currentPage={pageActual}
          />
        </Modal>
        <ModalConfirmation
          onFinish={onConfirmEvaluacion}
          ConfirmAutorize
          onCancel={() => setVisibleEvaluar(false)}
          contentTitle={`Evaluar ${recordName}`}
          open={visibleEvaluar}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmCloseMonth}
          Confirm
          onCancel={() => {
            setVisibleCloseMonth(false);
          }}
          open={visibleCloseMonth}
          contentTitle={`Cerrar ${recordName}`}
          loading={loading}
        />
        <ReporteFlexibleModal
          open={visibleReporteFlexible}
          onClose={() => setVisibleReporteFlexible(false)}
        />
        <CustomSearch
          form={form}
          open={openSearch}
          setVisible={setVisibleSearch}
          modalTitle="Buscar Empleado"
          firstInputLabel="No. de Empleado"
          firstInputName="numero_de_empleado"
          secondInputLabel="Nombre del Empleado"
          secondInputName="nombre"
          searchInputLabel="Apellido Paterno"
          searchInputName="apellido_paterno"
          thirdInputLabel="Apellido Materno"
          thirdInputName="apellido_materno"
          firstSelectLabel="Tipo de Nómina Empleado"
          firstSelectName="tipo_de_nomina_empleado"
          firstSelectDataSource={tiposDeNominaEmpleado}
          inputsNeeded={3}
          selectsNeeded={1}
          paginatedTable
          modalWidth={1400}
          columns={columnsEmpleado}
          baseURI={baseURIPagination}
          setSelectedRow={setSelectedEmpleadoSearch}
          onFinishGet={getEmpleadosConDatosOpFilteredPaginated}
          data={dataSearch}
          setData={setDataSearch}
          searchData={searchData}
          onChange={(row) => {
            setSelectedEmpleadoSearch(row);
          }}
        />
      </Spin>
    </Row>
  );
};

export default EvaluacionMensualReloj;
